import { render, staticRenderFns } from "./comp_AutocompleteSearchField-ProductItem.vue?vue&type=template&id=a29d1734&"
import script from "./comp_AutocompleteSearchField-ProductItem.vue?vue&type=script&lang=js&"
export * from "./comp_AutocompleteSearchField-ProductItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem,VListItemAvatar,VListItemContent})
